import { useNavigate as navigateHook } from "react-router-dom";
import { AppContext } from "../components/Menu/MenuButton";
import { DrawContext } from "../pages/DrawPage/DrawRoutes";

export const useNavigate = () => {
    const navigate = navigateHook();

    const customNavigate = (context: AppContext, options: { replace?: boolean, state?: any } = { replace: false }) => {
        const path = context === AppContext.None ? '/' : `/${context}`;
        navigate(path, options);    
    };

    return customNavigate;
};

export const useContextNavigate = <ContextType>() => {
    const navigate = navigateHook();

    const customNavigate = (context: ContextType, options: { replace?: boolean, state?: any } = { replace: false }) => {
        const path = `${context}`;
        navigate(path, options);
    };

    return customNavigate;
};

export const useDrawNavigate = () => {
    const navigate = navigateHook();
  
    const customNavigate = (drawContext: DrawContext, drawId: number) => {
        const path = `/${AppContext.Draw}/${drawContext}/${drawId}`;
        navigate(path);
    };
  
    return customNavigate;
};